<template>
  <b-modal id="update-password-modal"
           title="Update Password"
           ref="updatePasswordModal"
           size="md"
           button-size="sm"
           hide-header-close
           no-close-on-backdrop
           no-close-on-esc
           no-stacking
           centered
           @cancel="resetModal">

    <div class="container mb-2 p-0">
      <b-form-group
        id="current-password"
        label="Current Password:"
        label-class="font-weight-bold pt-0"
        label-for="current-password"
        label-cols-sm="5"
        label-cols-lg="4"
        description="Your Current Password">
        <b-form-input id="current-password"
                      type="password"
                      name="currentPassword"
                      v-model.trim="oldPassword"
                      placeholder="Current password (at least 12 characters)"
                      v-validate="'required|min:12|max:64'"
                      data-vv-as="Current Password"
                      data-vv-delay="500"
                      :class="{ 'is-invalid': errors.has('currentPassword') }"
                      :disabled="isLoadingUpdate"
                      aria-describedby="current-password-input-live-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="first-name-input-live-feedback">
          {{ errors.first("firstName") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="password-input-group"
                    label="Password"
                    label-for="password-input"
                    label-class="font-weight-bold"
                    label-cols-sm="5"
                    label-cols-lg="4"
                    description="Your New Password">
        <b-form-input id="password-input"
                      type="password"
                      name="password"
                      placeholder="Password (at least 12 characters)"
                      v-model.trim="password"
                      v-validate="'required|min:12|max:64'"
                      data-vv-as="Password"
                      data-vv-delay="500"
                      :class="{ 'is-invalid': errors.has('password') }"
                      :disabled="isLoadingUpdate"
                      ref="password"
                      aria-describedby="password-input-live-feedback">
        </b-form-input>
        <b-form-invalid-feedback id="password-input-live-feedback">
          {{ errors.first('password') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="confirm-password-input-group"
                    label="Confirm Password"
                    label-for="confirm-password-input"
                    label-class="font-weight-bold"
                    label-cols-sm="5"
                    label-cols-lg="4"
                    description="Reenter New Password">
        <b-form-input id="confirm-password-input"
                      type="password"
                      name="confirmPassword"
                      placeholder="Confirm password (must match)"
                      v-model.trim="confirmPassword"
                      v-validate="'required|confirmed:password|min:12|max:64'"
                      data-vv-as="Password"
                      data-vv-delay="500"
                      :class="{ 'is-invalid': errors.has('confirmPassword') }"
                      :disabled="isLoadingUpdate"
                      aria-describedby="confirm-password-input-live-feedback">
        </b-form-input>
        <b-form-invalid-feedback id="confirm-password-input-live-feedback">
          {{ errors.first('confirmPassword') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </div>

    <template slot="modal-footer">
      <b-btn variant="secondary" @click="() => { this.resetModal(); this.$refs.updatePasswordModal.hide() }">Cancel
      </b-btn>
      <b-btn variant="primary" @click="save()" :disabled="isLoadingUpdate">
        <b-spinner v-if="isLoadingUpdate" small></b-spinner>
        Save
      </b-btn>
    </template>
  </b-modal>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: "UpdatePasswordModal",
  data() {
    return {
      oldPassword: null,
      password: null,
      confirmPassword: null,
    }
  },
  watch: {},
  computed: {
    ...mapGetters({
      isLoadingUpdate: "user/profile/isLoadingUpdate",
      error: "user/profile/error",
    }),
  },
  methods: {
    ...mapActions({
      updateUserPassword: 'user/profile/updateUserPassword',
    }),
    resetModal() {
      this.oldPassword = null
      this.password = null
      this.confirmPassword = null
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateUserPassword({
            oldPassword: this.oldPassword,
            password: this.password,
            confirmPassword: this.confirmPassword
          }).then(update => {
            if (update) {
              this.resetModal()
              this.$refs.updatePasswordModal.hide()
            }
          })
        }
      })
    }
  }
}
</script>


<style class="scss" scoped>
</style>
